import {useCallback, type Ref} from 'react';
import {useTranslation} from 'react-i18next';
import {FormProvider} from 'react-hook-form';
import {WhosComingForm} from 'components/ReservationSettingsModal';
import {useGuestCountSubmit} from 'pages/Auth/hooks/useGuestCountSubmit';
import {PropertyLinkShell} from 'pages/SearchReservation/components/PropertyLinkShell';
import {usePendingPayments} from '../usePendingPayments';
import {SignedInAs, StepHeading} from './StepParts';

type Props = {
  columnRef: Ref<HTMLDivElement>;
  onDone: () => void;
};

function CountStep({columnRef, onDone}: Props) {
  const {t} = useTranslation();
  const payments = usePendingPayments();
  const handleDone = useCallback(() => onDone(), [onDone]);
  const {formMethods, onSubmit, formProps} = useGuestCountSubmit({onDone: handleDone});

  return (
    <PropertyLinkShell columnRef={columnRef}>
      <SignedInAs />
      <StepHeading
        lead={
          payments.length
            ? t('instant_check_in.then_finish_steps')
            : t('instant_check_in.then_register_guests')
        }
      >
        {t('instant_check_in.confirm_whos_coming')}
      </StepHeading>

      <FormProvider {...formMethods}>
        <WhosComingForm {...formProps} onSubmit={onSubmit} />
      </FormProvider>
    </PropertyLinkShell>
  );
}

export {CountStep};
